<template>
  <!-- 新增广告 -->
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="700px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="from-body">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="auto"
        :rules="rules"
        class="demo-ruleForm"
      >
        <el-form-item :label="$t('pages.system.text32')" prop="functionCode">
          <el-select
            v-model="ruleForm.functionCode"
            :placeholder="$t('button.pleaseSelect')"
            :disabled="dialogStatus == 2"
          >
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('pages.system.text30')" prop="adName">
          <el-input
            v-model="ruleForm.adName"
            :disabled="dialogStatus == 2"
          ></el-input>
        </el-form-item>
        <div class="doble">
          <el-form-item
            :label="$t('pages.system.text31')"
            prop="validStartTime"
          >
            <el-date-picker
              v-model="ruleForm.validStartTime"
              :disabled="dialogStatus == 2"
              type="datetime"
              :placeholder="$t('public.text2')"
              @change="startChange"
              :picker-options="pickerOptions0"
            >
            </el-date-picker>
          </el-form-item>
          <span style="margin: 0 10px; margin-top: 12px">-</span>
          <el-form-item prop="validStopTime" label-width="0">
            <el-date-picker
              v-model="ruleForm.validStopTime"
              :disabled="dialogStatus == 2"
              type="datetime"
              :placeholder="$t('public.text3')"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
        </div>

        <el-form-item :label="$t('pages.system.text38')">
          <DiluUploadImage
            :limit="1"
            accept=".jpg,.png"
            :fileList="fileList"
            @remove="removeimg"
            @success="success"
            :uploaDisabled="dialogStatus == 2"
            limitWidth="668"
            limitHeight="120"
          />
        </el-form-item>
        <el-form-item :label="$t('pages.system.text34')">
          <el-radio-group v-model="isFales" :disabled="dialogStatus == 2">
            <el-radio :label="0">{{ $t("pages.system.text40") }}</el-radio>
            <el-radio :label="1">{{ $t("pages.system.text39") }}</el-radio>
          </el-radio-group>
          <el-input
            v-if="isFales == 1"
            v-model="ruleForm.appAdBean.linkUrl"
            :disabled="dialogStatus == 2"
          >
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{
        dialogStatus == 2 ? $t("button.close") : $t("button.cancel")
      }}</el-button>
      <el-button type="primary" @click="submit" v-if="dialogStatus != 2">{{
        $t("button.determine")
      }}</el-button>
    </span>
  </el-dialog>
</template>


<script>
import DiluUploadImage from "../../../../components/pubilc/dilu-uploadimages.vue";
import { validatName } from "../../../../utils/util/test";
import { mapState } from "vuex";
import { resetDate } from "../../../../utils/util/validate";
export default {
  data() {
    return {
      pickerOptions0: {
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
             
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
        disabledDate: (time) => {
          return time.getTime() < Date.now();
        },
      },
      pickerOptions: {
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));
             
              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
        disabledDate: (time) => {
          return (
            time.getTime() < this.ruleForm.validStartTime ||
            time.getTime() < Date.now()
          );
        },
      },
      title: this.$t("pages.system.text41"),
      isFales: 0, //是否有链接 0：无 1：有
      fileList: [],
      ruleForm: {
        adName: "", // 广告名称
        appAdBean: {
          //单个广告图片名称、图片地址、跳转链接信息
          imageName: "", //图片名字
          imagePath: "", //图片地址
          linkUrl: null, //图片跳转链接
        },
        belongCustomerId: "", //	客户id
        functionCode: "", //应用路径
        validStopTime: "", //结束生效时间
        validStartTime: "", //开始生效时间
      },
      options: [],
      rules: {
        adName: [{ validator: validatName, trigger: "blur" }],
        functionCode: {
          required: true,
          message: this.$t("pages.system.text42"),
          trigger: "blur",
        },
        validStartTime: {
          required: true,
          message: this.$t("public.text2"),
          trigger: "blur",
        },
        validStopTime: {
          required: true,
          message: this.$t("public.text3"),
          trigger: "blur",
        },
      },
    };
  },
  components: {
    DiluUploadImage,
  },
  computed: {
    ...mapState(["platformData"]),
  },
  watch: {
    dialogVisible(newValue) {
      if (newValue) {
        if (this.dialogStatus == 1) {
          this.title = this.$t("pages.system.text43");
        }
        if (this.dialogStatus == 2) {
          this.title = this.$t("pages.system.text44");
        }
        if (this.dialogStatus != 0) {
          this.ruleForm = {
            adName: this.currentAdvertising.adName, // 广告名称
            appAdBean: {
              //单个广告图片名称、图片地址、跳转链接信息
              imageName: this.currentAdvertising.appAdAndUrl.imageName, //图片名字
              imagePath: this.currentAdvertising.appAdAndUrl.imagePath, //图片地址
              linkUrl: this.currentAdvertising.appAdAndUrl.linkUrl, //图片跳转链接
            },
            belongCustomerId: this.currentAdvertising.belongCustomerId, //	客户id
            functionCode: this.currentAdvertising.functionCode, //应用路径
            validStopTime: this.currentAdvertising.validStopTime, //结束生效时间
            validStartTime: this.currentAdvertising.validStartTime, //开始生效时间
            id: this.currentAdvertising.id,
          };
          this.fileList.push({
            name: this.currentAdvertising.appAdAndUrl.imageName,
            url: this.currentAdvertising.appAdAndUrl.imagePath,
          });
          if (this.currentAdvertising.appAdAndUrl.linkUrl) {
            this.isFales = 1;
          } else {
            this.isFales = 0;
          }
        }
        if (this.dialogStatus == 0) {
          this.title = this.$t("pages.system.text41");
        }
      }
    },
  },
  props: ["dialogVisible", "dialogStatus", "currentAdvertising"],
  mounted() {
    this.appAdvertisingGetFunctionCode();
  },
  methods: {
    startChange() {
      this.ruleForm.validStopTime = null;
    },
    //取消
    handleClose() {
      this.ruleForm = {
        adName: "", // 广告名称
        appAdBean: {
          //单个广告图片名称、图片地址、跳转链接信息
          imageName: "", //图片名字
          imagePath: "", //图片地址
          linkUrl: null, //图片跳转链接
        },
        belongCustomerId: "", //	客户id
        functionCode: "", //应用路径
        validStopTime: "", //结束生效时间
        validStartTime: "", //开始生效时间
        id: null,
      };
      this.fileList = [];
      this.isFales = 0;
      this.$refs["ruleForm"].resetFields();
      this.$emit("dialogClose");
    },
    //app广告-查出所有应用路径
    appAdvertisingGetFunctionCode() {
      this.request.appAdvertisingGetFunctionCode().then((res) => {
        this.options = res.data;
      });
    },
    //删除图片
    removeimg(e) {
      const i = this.fileList.findIndex((x) => x.name == e);
      this.fileList.splice(i, 1);
      this.ruleForm.appAdBean.imagePath = null;
      this.ruleForm.appAdBean.imageName = null;
      this.ruleForm.appAdBean.linkUrl = null;
    },
    //上传成功
    success(e) {
      this.ruleForm.appAdBean.imagePath = e.url;
      this.ruleForm.appAdBean.imageName = e.name;
      this.fileList = e.fileList;
    },
    //提交
    submit() {
      this.ruleForm.belongCustomerId = this.platformData.id;
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (!this.ruleForm.appAdBean.imagePath) {
            return this.$message.error(this.$t("pages.system.text45"));
          }
          this.ruleForm.validStopTime = resetDate(this.ruleForm.validStopTime); // 结束时间
          this.ruleForm.validStartTime = resetDate(
            this.ruleForm.validStartTime
          ); // 开始时间
          if (this.dialogStatus == 0) {
            if (this.isFales == 0) {
              this.ruleForm.appAdBean.linkUrl = null;
            } else {
              this.ruleForm.appAdBean.linkUrl =
                "https://" + this.ruleForm.appAdBean.linkUrl;
            }
            this.request.appAdvertisingAdd(this.ruleForm).then(() => {
              this.$message.success(this.$t("pages.system.text46"));
              this.handleClose();
              this.$emit("appAdvertisingList");
            });
          } else {
            if (this.isFales == 0) {
              this.ruleForm.appAdBean.linkUrl = null;
            }
            this.request.appAdvertisingEdit(this.ruleForm).then(() => {
              this.$message.success(this.$t("pages.system.text47"));
              this.handleClose();
              this.$emit("appAdvertisingList");
            });
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.from-body {
  padding: 0 5px;
  box-sizing: border-box;
}
.doble {
  display: flex;
}
</style>